import React from "react";
import styles from "./WhatCan.module.scss";
import Container from "../Container/Container";
import SectionTitle from "../SectionTitle/SectionTitle";
import { GlowingIcon } from "../../UI/GlowingIcon/GlowingIcon";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";

const WhatCan = () => {
    const matches2 = useMediaQuery("(min-width: 750px)");
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <Container>
                <div className={styles.body}>
                    <SectionTitle text={t("landing.what-can.title")} underlineText={"p2p"} className={styles.title} gradientText="Sairus" />
                    <div className={styles.list}>
                        {matches2 ? (
                            <>
                                <div className={styles.item}>
                                    <GlowingIcon name="stats-graph" className={styles.icon} />
                                    <span>{t("landing.what-can.p1")}</span>
                                </div>
                                <div className={styles.item}>
                                    <GlowingIcon name="segments" className={styles.icon} />
                                    <span className={["p2"].join("")}>{t("landing.what-can.p5")}</span>
                                </div>
                                <div className={styles.item}>
                                    <GlowingIcon name="grow-up" className={styles.icon} />
                                    <span>{t("landing.what-can.p3")}</span>
                                </div>
                                <div className={styles.item}>
                                    <GlowingIcon name="stats-graph" className={styles.icon} />
                                    <span className={["p2"].join("")}>{t("landing.what-can.p7")}</span>
                                </div>
                                <div className={styles.item}>
                                    <GlowingIcon name="brainstorm" className={styles.icon} />
                                    <span className={["p2"].join("")}>{t("landing.what-can.p6")}</span>
                                </div>
                                <div className={styles.item}>
                                    <GlowingIcon name="stats-circle" className={styles.icon} />
                                    <span>{t("landing.what-can.p2")}</span>
                                </div>
                                <div className={styles.item}>
                                    <GlowingIcon name="stats" className={styles.icon} />
                                    <span className={["p2"].join("")}>{t("landing.what-can.p4")}</span>
                                </div>
                                <div className={styles.item}>
                                    <GlowingIcon name="target" className={styles.icon} />
                                    <span className={["p2"].join("")}>{t("landing.what-can.p8")}</span>
                                </div>
                            </>
                        ) : (
                            <Swiper slidesPerView={1.4} spaceBetween={10} grabCursor={true}>
                                <SwiperSlide className={styles.slide}>
                                    <div className={styles.item}>
                                        <GlowingIcon name="stats-graph" className={styles.icon} />
                                        <span>{t("landing.what-can.p1")}</span>
                                    </div>
                                    <div className={styles.item}>
                                        <GlowingIcon name="grow-up" className={styles.icon} />
                                        <span>{t("landing.what-can.p5")}</span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className={styles.slide}>
                                    <div className={styles.item}>
                                        <GlowingIcon name="segments" className={styles.icon} />
                                        <span className={["p2"].join("")}>{t("landing.what-can.p3")}</span>
                                    </div>
                                    <div className={styles.item}>
                                        <GlowingIcon name="target" className={styles.icon} />
                                        <span className={["p2"].join("")}>{t("landing.what-can.p7")}</span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className={styles.slide}>
                                    <div className={styles.item}>
                                        <GlowingIcon name="stats-circle" className={styles.icon} />
                                        <span>{t("landing.what-can.p6")}</span>
                                    </div>

                                    <div className={styles.item}>
                                        <GlowingIcon name="stats" className={styles.icon} />
                                        <span className={["p2"].join("")}>{t("landing.what-can.p2")}</span>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className={styles.slide}>
                                    <div className={styles.item}>
                                        <GlowingIcon name="brainstorm" className={styles.icon} />
                                        <span className={["p2"].join("")}>{t("landing.what-can.p4")}</span>
                                    </div>
                                    <div className={styles.item}>
                                        <GlowingIcon name="stats-graph" className={styles.icon} />
                                        <span className={["p2"].join("")}>{t("landing.what-can.p8")}</span>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        )}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default WhatCan;
